import { render, staticRenderFns } from "./PlayerDerbies.vue?vue&type=template&id=5a80461a&"
import script from "./PlayerDerbies.vue?vue&type=script&lang=js&"
export * from "./PlayerDerbies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports